/// <reference path="../admin-lists/services/terms-condition.service.ts" />
/// <reference path="../admin-lists/services/terms-condition.service.ts" />
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OurUserService } from '../users/services/user.service';
import { IUserInfo } from '../users/models/userInfo.interface';
import { AuthorizeService } from '../../api-authorization/authorize.service';
import { Subscription } from 'rxjs';
import { consts } from '../common/modals/consts';
import { Observation, ObservationType } from '../domain-model/observation.class';
import { IObservation } from '../message-models/observation.interface';
import { ObservationModalService } from '../observations/services/observation-modal.service';
import { ObservationsService } from '../observations/services/observations.service';
import { AlertsService } from '../alerts/services/alerts.service';
import { BugLoggerModalService } from '../bug-logger/services/bug-logger-modal.service';
import { HelpModalService } from '../help/services/help-modal.service';
import { IHelpInfo } from '../help/models/i-help-info.interface';
import { SettingsProviderService } from '../common/settings-provider.service';
import { OperativeInfo } from "../domain-model/operative-info.class";
import { ExtendedJobLevel } from "../message-models/extended-job-level.class";
import { ExtendedRiskInfo } from "../message-models/extended-risk-info.class";
import { ListDataService } from "../services/list-data.service";
import { OperativeModalService } from "../operatives/services/operative-modal.service";
import { IRiskInfo } from "../message-models/risk-info.interface";
import { IEmploymentStatus } from "../message-models/employment-status.interface";
import { IJobLevelInfo } from "../message-models/job-level.interface";
import { IRiskMatrixEntry } from "../message-models/risk-matrix-entry.interface";
import { ErrorHandlingService } from "../services/error-handling.service";
import { IJobTitleInfo } from "../message-models/job-title.interface";
import { OperativesService } from "../operatives/services/operatives.service";
import { SettingsService } from '../services/settings.service';
import { HttpCancelService } from '../common/services/http-cancel.service';
import { MenuItem } from 'primeng/api';
import { TermsConditionService } from "../admin-lists/services/terms-condition.service";
import { IOptInEntry } from "../message-models/optin-entry.interface";
import { IOperativeTypeInfo } from '../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../message-models/business-unit.interface';
import { CompanyJobRoleService } from '../setting/job-role/services/company-job-role.service';
import { ICompanyJobTitle } from '../message-models/company-job-title.interface';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})

export class NavMenuComponent implements OnInit, OnDestroy {
  optInEntries: IOptInEntry[] = [];
  navItems: MenuItem[] = [];
  eCOMsGuidePdfUrl = '';
  companyId = '';
  isExpanded = false;
  loggedInUser: IUserInfo;
  subscription: Subscription;
  totalAlerts = 0;
  totalSupervisionAlerts = 0;
  totalLogItems = 0;
  private helpContext: IHelpInfo;
  showQuickHelp: boolean;
  currentHelp: IHelpInfo;
  allRisks: IRiskInfo[];
  jobTitles: IJobTitleInfo[];
  allCompanyJobTitles: ICompanyJobTitle[];
  allEmploymentStatuses: IEmploymentStatus[];
  allJobLevels: IJobLevelInfo[];
  riskMatrix: IRiskMatrixEntry[];
  allRisksLoaded = false;
  allEmploymentStatusesLoaded = false;
  allJobLevelsLoaded = false;
  riskMatrixLoaded = false;
  allJobTitlesLoaded = false;
  privacyStatementLink: string;
  environmentSetting: string;
  addOperativePermission = false;
  allOperativeTypesLoaded = false;
  allOperativeTypes: IOperativeTypeInfo[];
  allBusinessUnitsLoaded = false;
  allBusinessUnits: IBusinessUnitInfo[];

  private settingsProviderService: SettingsProviderService;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: OurUserService,
    private bugLoggerModalService: BugLoggerModalService,
    private alertsService: AlertsService,
    private authorizeService: AuthorizeService,
    private listDataService: ListDataService,
    private operativeModalService: OperativeModalService,
    private errorHandlingService: ErrorHandlingService,
    private settingsService: SettingsService,
    private operativesService: OperativesService,
    private httpCancelService: HttpCancelService,
    private helpService: HelpModalService,
    private observationsService: ObservationsService,
    private tncService: TermsConditionService,
    private companyJobRoleService: CompanyJobRoleService,
    private observationModalService: ObservationModalService) {
    this.settingsProviderService = new SettingsProviderService('');
    this.eCOMsGuidePdfUrl = this.settingsProviderService.baseUrl + 'Documentation/eCOMs_guide.pdf';
    this.settingsService.getPrivacyStatementUrl().subscribe(res => {
      this.privacyStatementLink = res;
    });
    this.settingsService.getEnvironment().subscribe(res => {
      if (res?.environment) {
        this.environmentSetting = res?.environment;
      }
    });
  }

  get companyIdIsSet(): boolean {
    return this.loggedInUser?.companyId && this.loggedInUser?.companyId != consts.emptyGuid;
  }

  signOut() {
    this.authorizeService.signOut('App').then(result =>
      this.router.navigate(['/'])
    );
  }

  openCompanyDocumentUploaderModal() {
    this.router.navigate(['/company-documents', 'add-document']);
  }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      if (user.isInternalAdminUser) {//Log out if in the admin role..
        this.httpCancelService.cancelPendingRequests();
        this.signOut();
        return;
      }
      this.companyId = this.loggedInUser?.companyId;
      this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
      this.alertsService.alertsCountSubject.subscribe(res => {
        this.totalAlerts = res;
      });
      this.alertsService.getSupervisionAlertsCountForCompany(user?.companyId).subscribe();
      this.alertsService.supervisionAlertsCountSubject.subscribe(res => {
        this.totalSupervisionAlerts = res;
      });
    });
    this.subscription = this.userService.getLoggedInUserSubject().subscribe(user => {
      this.loggedInUser = user;
    });
    this.initLists();
    this.tncService.getAllOptInEntries().subscribe(data => {
      this.optInEntries = data;
      //this.optInEntriesLoading = false;
    });

    this.listDataService.updateListRequired.subscribe(() => {
      this.initLists();
    });
  }

  initLists() {
    this.listDataService.getAllJobTitles().subscribe({
      next: response => {
        this.allJobTitlesLoaded = true;
        this.jobTitles = response;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
 
    this.companyJobRoleService.getCompanyJobTitlesByCompanyId(this.companyId).subscribe({
      next: response => {
        this.allJobTitlesLoaded = true;
        this.allCompanyJobTitles = response;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });

    this.listDataService.getAllRisks().subscribe({
      next: response => {
        this.allRisks = response;
        this.allRisksLoaded = true;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
    this.listDataService.getAllEmploymentStatuses().subscribe({
      next: response => {
        this.allEmploymentStatuses = response;
        this.allEmploymentStatusesLoaded = true;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
    this.listDataService.getAllJobLevels().subscribe({
      next: response => {
        this.allJobLevelsLoaded = true;
        this.allJobLevels = response;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
    this.listDataService.getRiskMatrix().subscribe({
      next: response => {
        this.riskMatrixLoaded = true;
        this.riskMatrix = response;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
    this.listDataService.getAllOperativeTypes().subscribe({
      next: response => {
        this.allOperativeTypesLoaded = true;
        this.allOperativeTypes = response;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
    this.listDataService.getBusinessUnitsForCompany(this.companyId).subscribe({
      next: response => {
        this.allBusinessUnitsLoaded = true;
        this.allBusinessUnits = response;
        this.updateNavBar();
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
  }

  initNavBar() {
    this.navItems = [
      //Links
      {
        label: this.loggedInUser?.companyName,
        icon: 'fa-solid fa-gauge-high',
        routerLink: ['dashboard'],
        visible: this.companyIdIsSet
      },
      //Operatives
      {
        label: 'Operatives',
        icon: 'fad fa-users',
        visible: this.companyIdIsSet && this.loggedInUser?.operativeOperations?.canRetrieve,
        items: [
          {
            label: 'Our Operatives',
            icon: 'fad fa-users',
            routerLink: ['operatives'],
          },
          { separator: true },
          {
            label: 'Add New Operative',
            icon: 'fad fa-user-plus',
            visible: this.addOperativePermission,
            command: () => this.addOperative(),
          },
          {
            label: 'Upload New Operatives',
            icon: 'fad fa-user-plus',
            visible: true,
            routerLink: ['operative-upload'],
          },
        ]
      },
      //Training Records
      {
        label: 'Training Records',
        icon: 'fad fa-graduation-cap',
        visible: this.companyIdIsSet && this.loggedInUser?.trainingRecordOperations?.canRetrieve,
        items: [
          {
            label: 'Operative Training',
            icon: 'fad fa-graduation-cap',
            routerLink: ['training-records'],
          },
          {
            separator: true,
            visible: this.loggedInUser?.trainingRecordOperations?.canUpdate || this.loggedInUser?.trainingRecordOperations?.canInsert,
          },
          {
            label: 'Training Courses',
            icon: 'fad fa-users-class',
            routerLink: ['training-courses'],
            visible: this.loggedInUser?.trainingRecordOperations?.canUpdate || this.loggedInUser?.trainingRecordOperations?.canInsert,
          },
        ]
      },
      //Documents
      {
        label: 'Documents',
        icon: 'fad fa-books',
        visible: this.companyIdIsSet && this.loggedInUser?.documentOperations?.canRetrieve,
        items: [
          {
            label: 'Enterprise Documents',
            icon: 'fad fa-books',
            routerLink: ['company-documents'],
          },
          {
            label: 'Operative Documents',
            icon: 'fad fa-books',
            routerLink: ['operative-documents'],
          },
          {
            separator: true,
            visible: this.loggedInUser?.documentOperations?.canInsert,
          },
          {
            label: 'Add Enterprise Document',
            icon: 'fad fa-books-medical',
            visible: this.loggedInUser?.documentOperations?.canInsert,
            command: () => this.openCompanyDocumentUploaderModal(),
          },
        ]
      },
      //Observations
      {
        label: 'Observations',
        icon: 'fad fa-eye',
        visible: this.companyIdIsSet && this.loggedInUser?.observationOperations?.canRetrieve,
        items: [
          {
            label: 'Enterprise Observations',
            icon: 'fad fa-eye',
            routerLink: ['company-observations'],
          },
          {
            label: 'Operative Observations',
            icon: 'fad fa-eye',
            routerLink: ['operative-observations'],
          },
          //{
          //  separator: true,
          //  visible: this.loggedInUser?.observationOperations?.canUpdate || this.loggedInUser?.observationOperations?.canInsert,
          //},
          //{
          //  label: 'Add Enterprise Observation',
          //  icon: 'fad fa-plus',
          //  visible: this.loggedInUser?.observationOperations?.canInsert,
          //  command: () => this.createCompanyObservation(),
          //},
        ]
      },
      //Help
      {
        label: 'Help',
        icon: 'fad fa-question-circle',
        visible: this.companyIdIsSet,
        items: [
          {
            label: 'How to use eCOMS',
            icon: 'fad fa-question',
            //url: this.settingsProviderService.baseUrl + 'Documentation/eCOMs_guide.pdf',
            url: 'https://ecaprodneecoms.blob.core.windows.net/ecoms-documents/eCOMs_guide.pdf',
            target: '_blank',
          },
          {
            label: 'Help about this page',
            icon: 'fad fa-question-circle',
            visible: this.currentHelp && this.showQuickHelp,
            command: () => this.helpAboutThisPageClick(),
          },
          {
            label: 'EAS Guide',
            icon: 'fad fa-external-link-alt',
            url: 'https://electrical.theiet.org/bs-7671/building-regulations/electrotechnical-assessment-specification/',
            target: '_blank',
          },
          {
            label: 'ECA Website',
            icon: 'fad fa-directions',
            url: 'https://www.eca.co.uk',
            target: '_blank',
          },
          {
            label: 'Privacy Statement',
            icon: 'fad fa-file-contract',
            url: this.privacyStatementLink,
            target: '_blank',
            visible: this.privacyStatementLink ? true : false,
          },
          {
            label: 'Terms & Conditions',
            icon: '',
            url: 'https://www.eca.co.uk/saas-master-terms',
            target: '_blank',

          },
        ]
      },
      //Alerts/Support
      {
        label: this.loggedInUser.displayName,
        styleClass: 'p-menuitem-right',
        items: [
          {
            label: 'Action Alerts',
            icon: 'fas fa-bell',
            routerLink: ['alerts'],
          },
          {
            label: 'Supervision Alerts',
            icon: 'fas fa-exclamation-triangle',
            routerLink: ['supervision-alerts'],
          },          
          { separator: true, },
          {
            label: 'Settings',
            icon: 'fad fa-cog',
            visible: this.companyIdIsSet,
            routerLink: ['company-settings']
          },
          { separator: true, },
          {
            label: 'Log a Problem',
            icon: 'fad fa-bug',
            command: () => this.logIssueClick(),
          },
          { separator: true, },
          {
            label: 'Log Out',
            icon: 'fad fa-sign-out',
            command: () => this.signOut(),
          },
        ]
      }
    ]
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  clearCompanySelectiion() {
    this.loggedInUser.companyId = consts.emptyGuid;
    this.loggedInUser.companyName = '';
    this.userService.updateUserCompanyDetails(consts.emptyGuid, '');
    this.router?.navigate(['/company-search']);
  }

  createCompanyObservation() {
    const observationModalHeading = 'New observation of ' + this.loggedInUser?.companyName;
    const selectedObservation = new Observation({} as IObservation);
    this.observationModalService.createOrEditObservation(selectedObservation, observationModalHeading, true, ObservationType.Company).subscribe(observationModalRef => {
      observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
        if (observationResult !== null) {
          observationResult.observationType = ObservationType.Company;
          this.observationsService.createOrUpdateCompanyObservation(observationResult, this.loggedInUser?.companyId).subscribe(companyObservation => {
            this.router?.navigate(['/company-observations']);
          });
          observationModalRef.dynamicDialogRef.close();
        }
      });
    });
  }

  logIssueClick() {
    this.bugLoggerModalService.openLogItemEditorModal();
  }

  helpAboutThisPageClick() {
    this.helpService.openHelpModal(this.currentHelp);
  }

  addOperative() {
    const newOperative = new OperativeInfo();
    newOperative.companyId = this.companyId;
    newOperative.currentBusinessUnitId = consts.emptyGuid;

    const defaultEmploymentStatus = this.allEmploymentStatuses.find(s => s.isDefault);
    newOperative.currentEmploymentStatusId = defaultEmploymentStatus?.id;
    const jobLevels: ExtendedJobLevel[] = [];
    this.allJobLevels.forEach(l => {
      jobLevels.push(new ExtendedJobLevel(l));
    });

    const risks: ExtendedRiskInfo[] = [];
    this.allRisks.forEach(r => {
      risks.push(new ExtendedRiskInfo(r));
    });
   
    this.operativeModalService.openOperativeEditorModal(newOperative, 'Add a New Operative',
      this.jobTitles, this.allCompanyJobTitles, jobLevels, risks, this.allEmploymentStatuses, this.allOperativeTypes, this.allBusinessUnits, true).subscribe(modalRef => {
        modalRef.content.saveOperativeRequested.subscribe(operative => {
          if (operative) {
            this.operativesService.createOrUpdateOperative(operative).subscribe(result => {
              if (result) {
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                  this.router.navigate(['operative/' + result.id]));
              }
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
          }
        });
      });
  }

  canAddOperative(): boolean {
    return this.allRisksLoaded && this.allEmploymentStatusesLoaded && this.allJobLevelsLoaded && this.riskMatrixLoaded && this.allJobTitlesLoaded && this.allOperativeTypesLoaded && this.loggedInUser?.operativeOperations?.canInsert
  }

  updateNavBar() {
    this.addOperativePermission = this.canAddOperative();
    if (this.addOperativePermission) {
      this.initNavBar();
    }
  }
}
